import { FormattedMessage } from 'react-intl';

import { useAppSelector } from '@/configuration/setup/hooks';

const AccessDeniedPage = () => {
    const userProfile = useAppSelector((state) => state.login.userProfile);
    const subject = userProfile?.sub ?? 'unknown';

    return (
        <div className="container-fluid padding-top-50 text-center" style={{ maxWidth: 600 }}>
            <span className="uikit-icon icon-lock text-color-danger" style={{ fontSize: 64 }} aria-hidden="true" />
            <h2 className="margin-top-20 margin-bottom-10">
                <FormattedMessage id="intl-msg:accessDenied.title" />
            </h2>
            <p className="text-color-dark text-size-16">
                <FormattedMessage id="intl-msg:accessDenied.message" />
            </p>
            <p className="text-color-gray margin-top-15 text-size-14">
                <FormattedMessage id="intl-msg:accessDenied.subject" /> <code>{subject}</code>
            </p>
            <p className="text-color-gray text-size-14">
                <FormattedMessage id="intl-msg:accessDenied.contact" />
            </p>
        </div>
    );
};

export default AccessDeniedPage;
